<template>
    <div>
        <!--BEGIN-->
        <div class="form-group" v-if="(method == 'put')">
            <label>Cartella padre</label>
            <select v-model="data_parent_folder" class="form-control">
                <option value="0">
                    /
                </option>
                <option v-for="folder in folders_array" :value="folder.id">
                    {{folder.name}}
                </option>
            </select>
        </div>

        <input type="hidden" name="modelId" :value="this.model_id">
        <input type="hidden" name="model" :value="this.model">

        <div class="form-group">
            <label>Nome</label>
            <input name="name" class="form-control" required v-model="data_name_link">
        </div>
        <div class="form-group">
            <label>Url</label>
            <input name="url" class="form-control" required v-model="data_url_link">

        </div>
        <div class="form-buttons">
            <button class="btn btn--green" type="button" @click="submitForm()">
                {{__("misc.save")}}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {

            this.data_name_link = this.name_link;
            this.data_url_link = this.url_link;
        },
        data () {
            return {
                data_name_link : "",
                data_url_link : "",
                data_parent_folder : this.parent_folder
            }
        },

        methods: {
            submitForm(){
                /*
                  Initialize the form data
                */
                let params = {

                    "model" : this.model,
                    "folder" : this.data_parent_folder,
                    "name" :this.data_name_link,
                    "url" :this.data_url_link,

                    "module" : this.module_name,
                    "share" : this.share,
                    "modelId" : this.model_id,
                    "category" : this.category

                };
                if(this.method === "put"){
                    /*
                  Make the request to the POST /multiple-files URL
                */

                    axios.put( this.route_form,
                        params,
                    ).then(function(response){


                        if(response.data.closePopup){

                            app.__vue__.$refs.vue_popup.active = false;
                            app.__vue__.$refs.document_sharing.readFolder(response.data.folder);

                        }
                        else{
                            //add normal file, reload attachment page with url returned from server
                            console.log("Document normale",response.data);
                            app.__vue__.$refs.vue_popup.toggle("Allegati",response.data.urlHomeAttachments);
                        }




                    })
                        .catch(function(error){
                            if (error.response) {
                                console.log(error.response.data);
                                console.log(error.response.status);
                                console.log(error.response.headers);
                            }
                        })
                        .finally(function (){

                        });

                    //call sync function
                    if(this.share) {

                        app.__vue__.$refs.document_sharing.readFolder(this.folder);
                    }
                }
                else if(this.method === "post"){

                    /*
                  Make the request to the POST /multiple-files URL
                */
                    axios.post( this.route_form,params).then(function(response){
                      Vue.swal.fire({
                        title: 'Link inserito con successo',
                        text: "",
                      });
                        if(response.data.closePopup){

                            app.__vue__.$refs.vue_popup.active = false;
                            app.__vue__.$refs.document_sharing.readFolder(response.data.folder);

                        }
                        else{
                            //add normal file, reload attachment page with url returned from server
                            console.log("URL",response.data.urlHomeAttachments);
                            app.__vue__.$refs.vue_popup.toggle("Allegati",response.data.urlHomeAttachments);
                        }
                    })
                        .catch(function(error){
                            if (error.response) {
                                Vue.swal.fire(error.response.message);
                            }
                        })
                        .finally(function (){

                        });
                }
            },
        },
        props:{

                route_form:{
                    type: String,
                    required : true
                },
                method:{
                    type: String,
                    required : true
                },
                parent_folder:{
                    type: Number,
                    required : true
                },
                name_link:{
                    type: String,
                    required : true
                },
                url_link:{
                    type: String,
                    required : true
                },
                module_name:{
                    type: String,
                    required : true
                },
                model:{
                    type: String,
                    required : true
                },
                share:{
                    type: Number,
                    required : true
                },
                model_id:{
                    type: Number,
                    required : true
                },
                folders_array:{
                    type:Array,
                    required:true
                },
                category :{
                    type: String,
                    required: false,
                    default:null
                },

        },


    }
</script>

